export default "__VITE_ASSET__CcK$UyzC__"